export enum OsName {
  Windows = 'Windows',
  MacOS = 'macOS',
  Linux = 'Linux',
  Android = 'Android',
  IOS = 'iOS',
  Unknown = 'Unknown',
}
